import React from 'react';

const Programs = () => {
    return (
        <section id="programs">
            <h2>Affiliated Programs</h2>
            <ul>
                <li>Environmental Life Sciences</li>
                <li>Microbiology PhD</li>
                <li>Molecular and Cellular Biology</li>
            </ul>
        </section>
    );
};

export default Programs;
